import React, { useEffect } from "react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../../components/ui/select";
import { useTabConfigStore } from "../../store/TabConfig/tab-config.store";
import { useCentralStore } from "../../store/Central";

interface JobTabsConfigSelectProps {
	value: string | null | undefined;
	onChange: (value: string | null) => void;
	emptyLabel?: string;
	width?: string;
	className?: string;
	disabled?: boolean;
}

export const JobTabsConfigSelect: React.FC<JobTabsConfigSelectProps> = ({
	value,
	onChange,
	emptyLabel = "Keine",
	width = "100%",
	className,
	disabled = false,
}) => {
	const organizationId = useCentralStore((state) => state.organization?.id);
	const { configurations, loading, fetchConfigurations } = useTabConfigStore(
		(state) => ({
			configurations: state.configurations,
			loading: state.loading,
			fetchConfigurations: state.fetchConfigurations,
		})
	);

	useEffect(() => {
		if (organizationId) {
			fetchConfigurations(organizationId);
		}
	}, [organizationId, fetchConfigurations]);

	const handleChange = (selectedValue: string) => {
		if (selectedValue === "_NONE_") {
			onChange(null);
		} else {
			onChange(selectedValue);
		}
	};

	const currentValue = value || "_NONE_";

	return (
		<Select
			value={currentValue}
			onValueChange={handleChange}
			disabled={disabled || loading}
		>
			<SelectTrigger
				className={className}
				style={{ width }}
				data-testid="job-tabs-config-select"
				aria-label="Job tabs configuration auswählen"
			>
				<SelectValue placeholder="Auswählen..." />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="_NONE_" data-testid="job-tabs-config-none">
					{emptyLabel}
				</SelectItem>
				{configurations.map((config) => (
					<SelectItem
						key={config.id}
						value={config.id}
						data-testid={`job-tabs-config-${config.id}`}
					>
						{config.name}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};